import { useState } from 'react'
import classNames from 'classnames'

import CircleLoader from '@components/CircleLoader'

import { npsAdminLogin } from '../../actions'
import { getNpsAdminAuthError, npsAdminLoginPending } from '../../selectors'

import styles from '../styles.module.scss'

const AdminLoginView = ({ npsAdminLogin, authError, pending }) => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')

    const onSubmit = event => {
        event.preventDefault()
        npsAdminLogin(username.trim(), password)
    }

    return (
        <div className={classNames('container', styles.npsContent, styles.npsLogin)}>
            <h1 className={styles.npsContainerTitle}>
                <T>nps.admin.login.title</T>
            </h1>
            <form onSubmit={onSubmit}>
                <div className="form-group">
                    <label htmlFor="npsAdminUsername">
                        <T>nps.admin.login.username.label</T>
                    </label>
                    <input
                        id="npsAdminUsername"
                        className="form-control"
                        type="text"
                        autoComplete="username"
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="npsAdminPassword">
                        <T>nps.admin.login.password.label</T>
                    </label>
                    <input
                        id="npsAdminPassword"
                        className="form-control"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                    />
                </div>
                {authError && (
                    <p className="text-danger">
                        <T>nps.admin.login.error</T>
                    </p>
                )}
                <button
                    type="submit"
                    className="btn btn-primary text-uppercase font-weight-bold"
                    disabled={pending || !username || !password}>
                    {pending ? <CircleLoader size="small" /> : <T>nps.admin.login.submit</T>}
                </button>
            </form>
        </div>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            authError: getNpsAdminAuthError,
            pending: npsAdminLoginPending,
        }),
        { npsAdminLogin }
    )
)(AdminLoginView)
